package com.devi3east.bashbuddy.prizeList.requests

import com.devi3east.bashbuddy.prizeList.domain.models.PrizeType
import kotlinx.datetime.Instant
import kotlinx.serialization.Serializable

@Serializable
data class CreatePrizeSeriesRequest(
    val prizeType: PrizeType,
    val count: Int,
    val startInstant: Instant,
    val intervalMinutes: Int
)